// App.js
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './components/LoginForm';
import AnimalDetails from './components/eidday/AnimalDetails';
import InsertAnimalStatus from './components/eidday/InsertAnimalStatus';
import { ViewAnimalStatus } from './components/eidday/ViewAnimalStatus';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <Router>
      <div className="container">
        <Routes>
          <Route
            path="/"
            element={
              loggedIn ? (
                <AnimalDetails />
              ) : (
                <LoginPage onLoginSuccess={() => setLoggedIn(true)} />
              )
            }
          />
          <Route
            path="/insertAnimalStatus"
            element={
              loggedIn ? (
                <InsertAnimalStatus />
              ) : (
                // Redirect to login if not logged in
                <Navigate to="/" replace />
              )
            }
          />
          {/* Unprotected route – no login required */}
          <Route path="/status" element={<ViewAnimalStatus />} />
          {/* Optional: catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
